<ng-snotify></ng-snotify>